import { render, staticRenderFns } from "./bankStatementDailyTab.vue?vue&type=template&id=2c09e442&lang=pug"
import script from "./bankStatementDailyTab.vue?vue&type=script&lang=js"
export * from "./bankStatementDailyTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports